import { createSelector } from 'reselect'

import type { DeliveryOption, I18N, Listing, ListingResponse, ListingStateType } from './types'

export const listingSelector = createSelector(
    (state: ListingStateType) => state.data,
    (data: ListingResponse | undefined): Listing | undefined => data?.listing,
)

export const deliveryOptionsSelector = createSelector(
    (state: ListingStateType) => state.data,
    (data: ListingResponse | undefined): DeliveryOption[] | undefined => data?.deliveryOptions,
)

export const i18nListingDataSelector = createSelector(
    (state: ListingStateType) => state.data,
    (data: ListingResponse | undefined): I18N | undefined => data?.i18n,
)
